import { useState } from 'react'

import {
  listCategories as apiListCategories,
  Category
} from '../../../../../services/category'

export function useCategory() {
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(false)

  const listCategories = () => {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => apiListCategories())
      .then(data => setCategories(data.categories))
      .finally(() => setLoading(false))
  }

  return {
    categories,
    loading,
    listCategories
  }
}
